import {Button, Stack} from "@mui/material";
import pleshDark from "../../../theme/pleshDark";
import React from "react";
import axios from "axios";
import {API_URL, TOOLPRESS_API} from "../../../config";
import {useParams} from "react-router-dom";

const LinksQuestion = ({risposte: links, elementId}) => {
    const {eventOwnerId, id} = useParams()

    return (
        <Stack mt={3} alignItems={'center'} spacing={2} px={3}>
            {links.map((link, i) => (
                <Button variant={'default'} href={link.url} target={'_blank'}
                        onClick={() => {
                            axios.post(`${API_URL}updatelinkcounter/${eventOwnerId}/${id}/${elementId}`, {linkIndex: i})
                              .then(() => {console.log("updated")})
                              .catch((error) => {console.log("LinksQuestion > error: ", error)})
                        }}
                        fullWidth
                        sx={{
                            minHeight: '60px',
                            fontWeight: 'bold',
                            background: link.color || pleshDark.palette.accent.secondary2
                        }}
                >
                    {link.label}
                </Button>
            ))}
        </Stack>
    )
}

export default LinksQuestion